var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.175659 0H36.1757V36H0.175659V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64141 30.0842L12.3964 28.417C12.9279 29.3593 13.4114 30.1566 14.5711 30.1566C15.6827 30.1566 16.3836 29.7218 16.3836 28.0303V16.5275H19.7667V28.0782C19.7667 31.5822 17.7127 33.1771 14.7161 33.1771C12.0098 33.1771 10.4388 31.7754 9.64136 30.0839",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6042 29.7217L24.3589 28.1268C25.084 29.311 26.0265 30.1809 27.6938 30.1809C29.0956 30.1809 29.9894 29.48 29.9894 28.5134C29.9894 27.3535 29.0712 26.9426 27.5246 26.2662L26.679 25.9035C24.2382 24.8646 22.619 23.5596 22.619 20.8047C22.619 18.2674 24.5522 16.334 27.573 16.334C29.7238 16.334 31.2704 17.0832 32.3818 19.0407L29.7478 20.7322C29.1678 19.6931 28.5397 19.2824 27.5731 19.2824C26.5823 19.2824 25.954 19.9107 25.954 20.7322C25.954 21.7471 26.5823 22.158 28.0321 22.7864L28.8778 23.1488C31.7535 24.3814 33.3726 25.6378 33.3726 28.4651C33.3726 31.5101 30.9803 33.1774 27.7664 33.1774C24.6249 33.1774 22.5949 31.6792 21.6042 29.7217Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.175659)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.676a83a94bf5b601aae6ffbc8c626b01.svg";
export { ForwardRef as ReactComponent };